import {
  extractDeliveryNoteDocumentMessageInputSchema,
  ExtractDeliveryNoteDocumentMessageInput,
} from '@prompt-bridge/shared/validations';

export const isExtractDeliveryNoteDocumentMessageInput = (
  value: unknown
): value is ExtractDeliveryNoteDocumentMessageInput => {
  const result = extractDeliveryNoteDocumentMessageInputSchema.safeParse(value);
  return result.success;
};
